module.exports = __webpack_public_path__ + "img/base_hiver_snow_park.1c7f4b2b.svg";